module.exports = "https://coursera_assets.s3.amazonaws.com/images/8394e9bd1e9c1cb5d5c77d6fac94471d.png";